import { getConversationById } from '@app/helpers'
import { ConversationItem } from '@app/models'

import { ChatState, FetchMessagesSuccessPayload } from '../types'
import { ensureUniqueMessages } from './ensureUniqueMessages'

export const onFetchMessagesSuccess = (
  state: ChatState,
  { id, messages, total }: FetchMessagesSuccessPayload
): ChatState => {
  const conversation = getConversationById(state.conversations, id)
  if (!conversation) {
    return state
  }

  const conversations: Record<number, ConversationItem> = {
    ...state.conversations,
    [id]: {
      ...conversation,
      messages: ensureUniqueMessages([...conversation.messages, ...messages]),
      total,
      fetching: 'SUCCEED',
    },
  }

  return {
    ...state,
    conversations,
  }
}
